import classNames from 'classnames'
import React, {useEffect, useRef} from 'react'
import {Pagination} from 'wix-ui-tpa/cssVars'
import {useSettings} from '../../../hooks/use-settings'
import settingsParams from '../../../settingsParams'
import {useWidgetActions, useWidgetState} from '../../hooks/state-provider'
import {getCurrentPage, getEventsTotal} from '../../selectors/events'
import {classes} from './events-list-pagination.st.css'
import {EventsListPaginationProps} from './interfaces'

export const EventsListPagination = ({containerRef, mobile, className}: EventsListPaginationProps) => {
  const currentPage = useWidgetState(getCurrentPage)
  const {loadEventsPage} = useWidgetActions()
  const {get: getSetting} = useSettings()
  const total = useWidgetState(getEventsTotal)
  const limit = getSetting(settingsParams.eventsPerPage)
  const totalPages = Math.ceil(total / limit)
  const firstRender = useRef(true)

  useEffect(() => {
    if (!firstRender.current) {
      containerRef.current.scrollIntoView({behavior: 'smooth'})
    }
    firstRender.current = false
  }, [currentPage])

  return (
    <div className={classNames(classes.container, {[classes.container__mobile]: mobile}, className)}>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onChange={({page}) => {
          loadEventsPage({page, limit})
        }}
        showFirstLastNavButtons
        className={classes.pagination}
      />
    </div>
  )
}
